import type { Intersection2d } from "@logic/lib/2d"
import { atom, selector, useRecoilTransaction_UNSTABLE } from "recoil"

import {
  areaIndex,
  getInsetAreaFaces,
} from "~/containers/LegacyDesigner/state/elements"
import { readonlyTransactors } from "~/containers/LegacyDesigner/state/elements/transactions"
import type { TransactionOperation } from "~/containers/LegacyDesigner/state/elements/transactions"

import { nextPlaybackStep, prevPlaybackStep } from "../visualizeSteps"

export const getDivisionIntersections: TransactionOperation<
  undefined,
  Intersection2d[][]
> = (transactors) => {
  const areaIds = transactors.get(areaIndex)

  return areaIds.map((id) => {
    const {
      procedure: { meshIntersections },
    } = getInsetAreaFaces(transactors, id)

    return meshIntersections
  })
}

export const divisionIntersectionsState = selector<Intersection2d[][]>({
  key: `divisionIntersections`,
  get: ({ get }) => getDivisionIntersections(readonlyTransactors(get)),
})

export const divisionPlaybackState = atom<[number, number]>({
  key: `divisionIntersectionsPlayback`,
  default: [0, 0],
})

export const nextDivisionStep: TransactionOperation = (transactors) =>
  nextPlaybackStep(transactors, {
    getItems: getDivisionIntersections,
    playbackState: divisionPlaybackState,
  })

export const prevDivisionStep: TransactionOperation = (transactors) =>
  prevPlaybackStep(transactors, {
    getItems: getDivisionIntersections,
    playbackState: divisionPlaybackState,
  })

export const useDivisionStepNavigation = (): [
  prev: () => void,
  next: () => void,
] => [
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => prevDivisionStep(transactors),
  ),
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => nextDivisionStep(transactors),
  ),
]
